import React, { useEffect, useRef } from "react";
import "./modals.css";

const FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';

// One dialog look for the legal notices, the crisis resources and the app messages.
// Works on the sign-in pages too (no theme tokens there), and follows dark mode when the app is dark.
export default function ModalShell({ title, subtitle, onClose, children, footer, tone = "default", label }) {
  const card = useRef(null);
  const dark = typeof document !== "undefined" && !!document.querySelector(".app-container.dark-mode");

  useEffect(() => {
    const previous = document.activeElement;
    const el = card.current;
    const first = el && el.querySelector("[data-autofocus]");
    (first || el).focus();
    return () => {
      if (previous && previous.focus) previous.focus();
    };
  }, []);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape" && onClose) {
        e.stopPropagation();
        onClose();
        return;
      }
      if (e.key !== "Tab" || !card.current) return;
      const items = [...card.current.querySelectorAll(FOCUSABLE)].filter((n) => n.offsetParent !== null);
      if (items.length === 0) {
        e.preventDefault();
        return;
      }
      const firstItem = items[0];
      const lastItem = items[items.length - 1];
      if (e.shiftKey && document.activeElement === firstItem) {
        e.preventDefault();
        lastItem.focus();
      } else if (!e.shiftKey && document.activeElement === lastItem) {
        e.preventDefault();
        firstItem.focus();
      }
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div className={`rg-modal${dark ? " is-dark" : ""}${tone === "care" ? " is-care" : ""}`} onClick={onClose}>
      <div
        ref={card}
        className="rg-modal-card"
        role="dialog"
        aria-modal="true"
        aria-label={label || title}
        tabIndex={-1}
        onClick={(e) => e.stopPropagation()}
      >
        <header className="rg-modal-head">
          <div className="rg-modal-titles">
            <h2 className="rg-modal-title">{title}</h2>
            {subtitle ? <p className="rg-modal-sub">{subtitle}</p> : null}
          </div>
          {onClose ? (
            <button type="button" className="rg-modal-x" aria-label="Close" onClick={onClose}>
              <span aria-hidden="true" />
            </button>
          ) : null}
        </header>
        <div className="rg-modal-body">{children}</div>
        {footer ? <footer className="rg-modal-foot">{footer}</footer> : null}
      </div>
    </div>
  );
}
